import styled from 'styled-components'
import { Title } from 'sharedKernel/styledComponents/visualizationComponents/styles'

export const FormTitle = styled.div`
  margin-top: 51px;
  h1 {
    font-size: 22px;
  }
`

export const LoadindContainer = styled.div`
  height: 40rem;
`

export const ScreenContainer = styled.div`
  width: 90%;
  padding: 3rem 0;
  margin: auto;
`
export const FormIdeaSectionName = styled.h4`
  font-size: 1.5rem;
`

export const FormIdeaAnswer = styled.p`
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 1.75rem;
  text-align: left;
`

export const FormIdeaSections = styled.div`
  padding-top: 0.5rem;
  height: 100%;
  overflow-y: scroll;
  scroll-behavior: smooth;
  position: relative;
  border-radius: 0.38rem;
  background-color: var(--white);
`
export const FormChallengeHeader = styled.div`
  align-items: center;
  position: -webkit-sticky;
  position: sticky;
  top: 79px;
  z-index: 5;

  background-color: var(--background);
  box-shadow: 0 5px 2px -2px var(--shadow-smooth), 32px 0 var(--background), -32px 0 var(--background);
`

export const PageHeaderRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 16px;
  width: 100%;
`

export const TitleGroup = styled.div`
  display: flex;
  align-items: center;
  flex: 1 1 0;
  min-width: 0;
  gap: 15px;
`

export const SolutionTitle = styled(Title)`
  width: auto;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const ChangeDataButtonArea = styled.div`
  flex-shrink: 0;
  margin-left: auto;
`

export const EditIconButton = styled.button`
  background-color: var(--white);
  border: 2px solid var(--primary);
  cursor: pointer;
  color: var(--primary);
  font-size: 1rem;
  flex-shrink: 0;
  padding: 6px 16px;
  border-radius: 3px;
  font-weight: 500;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:focus {
    outline: 2px solid var(--input-focus-shadow);
    outline-offset: 2px;
  }
`
